import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { filter } from 'rxjs/operators';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-company-admin-sidebar',
  templateUrl: './company-admin-sidebar.component.html',
  styleUrls: ['./company-admin-sidebar.component.css'],
})
export class CompanyAdminSidebarComponent implements OnInit {
  showLogoutModal = false;
  showDeleteModal = false;
  isMobile: boolean = false;
  userLang: any = 'en';

  activeTab: 'profile' | 'services' = 'profile';
  showServicesDropdown = false;
  currentRoute: string = '';

  private pageTitles: { [key: string]: string } = {
    'company-profile':   'companyAdmin.companyProfile',
    'positions':         'companyAdmin.positions',
    'job-posts':         'companyAdmin.jobPosts',
    'job-applications':  'companyAdmin.jobApplications',
    'virtual-interviews': 'companyAdmin.virtualInterviews',
    'interview-setup':   'companyAdmin.interviewSetup',
  };

  constructor(
    private router: Router,
    private userService: UserService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {
    this.userLang = this.localizationService.getUserLang();
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 991;

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentRoute = event.url;
        if (!this.isCompanyProfilePage()) {
          this.showServicesDropdown = false;
        }
      });

    this.currentRoute = this.router.url;

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLang = event.lang;
    });
  }
  openLogoutModal()  { this.showLogoutModal = true;  }
  closeLogoutModal() { this.showLogoutModal = false; }
  openDeleteModal()  { this.showDeleteModal = true;  }
  closeDeleteModal() { this.showDeleteModal = false; }

  confirmLogout() {
    this.userService.deleteTokenInfo();
    this.userService.deleteUserInfo();
    this.showLogoutModal = false;
    this.router.navigate(['/']);
  }

  deleteUserAccount() {
    this.userService.deleteUserAccount().subscribe({
      next: () => {
        this.userService.deleteTokenInfo();
        this.userService.deleteUserInfo();
        this.router.navigate(['/']);
      },
      error: (err) => console.error('Error deleting account:', err),
    });
  }

  // ── Mobile tab helpers ─────────────────────────────────────────
  setActiveTab(tab: 'profile' | 'services') {
    this.activeTab = tab;
    this.showServicesDropdown = tab === 'services';
  }

  closeDropdown() {
    this.showServicesDropdown = false;
    this.activeTab = 'profile';
  }

  // ── Route helpers ──────────────────────────────────────────────
  isCompanyProfilePage(): boolean {
    return (
      this.currentRoute.includes('company-profile') ||
      this.currentRoute.endsWith('/company-admin') ||
      this.currentRoute === ''
    );
  }

  getCurrentPageTitle(): string {
    const segments = this.currentRoute.split('/');
    const lastSegment = segments[segments.length - 1];
    return this.pageTitles[lastSegment] || 'companyAdmin.title';
  }

  goBackToDashboard(): void {
    this.router.navigate(['/company-admin/company-profile']);
    this.activeTab = 'profile';
    this.showServicesDropdown = false;
  }

  goBacktoHome(): void {
    this.router.navigate(['/']);
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 991;
  }
}
